import { render, staticRenderFns } from "./contentPanel.vue?vue&type=template&id=4469b9f0"
import script from "./contentPanel.vue?vue&type=script&lang=js"
export * from "./contentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Cta: require('/vercel/path0/components/ui/cta.vue').default})
